import React, { Component, ReactNode } from 'react';
import classnames from 'classnames';
import styles from './SectionColumn.module.scss';

interface ISectionColumnProps {
	children?: ReactNode;
	title?: string;
	showTitle?: boolean;
	className?: string;
}

export default class SectionColumn extends Component<ISectionColumnProps> {
	render() {
		const { showTitle = true, className } = this.props;

		return (
			<div className={classnames(styles.sectionColumn, className)}>
				{showTitle ? <div className={styles.title}>{this.props.title}</div> : null}
				<div className={styles.list}>{this.props.children}</div>
			</div>
		);
	}
}
